<template>
  <div class="side-edit-content p-5">
    <strong class="title-main d-block mb-4">{{ $t('views.seller.integrations.config.edit.title') }}</strong>

    <!-- Exibe token -->
    <div :class="isInputError('update_token')" @click="removeError('update_token')">
      <strong class="title-medium">API Key</strong>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" placeholder="Informe o API Key do Notazz" class="form-input" v-model="token" trim></b-form-input>
          </b-form-group>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_token') }}
      </span>
    </div>

    <!-- Exibe actions -->
    <div :class="isInputError('update_use_name_product')" @click="removeError('update_use_name_product')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Exibir nome do produto na Nota Fiscal?</strong>
      </div>
      <multiselect 
        v-model="use_name_product.value"
        :options="use_name_product.items" 
        :loading="use_name_product.loading"
        :disabled="use_name_product.block"
        :multiple="false" 
        :show-labels="false" 
        :searchable="false"
        class="new-style"
        placeholder="Digite para pesquisar"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a opção desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('update_use_name_product') }}</span>
    </div>

    <!-- Exibe envio -->
    <div :class="isInputError('update_send_email')" @click="removeError('update_send_email')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Enviar email com a Nota Fiscal parar o cliente?</strong>
      </div>
      <multiselect 
        v-model="send_email.value"
        :options="send_email.items" 
        :loading="send_email.loading"
        :disabled="send_email.block"
        :multiple="false" 
        :show-labels="false" 
        :searchable="false"
        class="new-style"
        placeholder="Digite para pesquisar"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a opção desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('update_send_email') }}</span>
    </div>

    <!-- Exibe a URL webhook -->
    <div>
      <strong class="title-medium mt-4">Copie e adicione a url na configuração de webhook na NotaZZ</strong>
      <b-form-group id="fieldset-token" label-for="input-token">
          <b-form-input 
            id="update_url_webhook" 
            placeholder="URL Webhook" 
            class="form-input copy" 
            :value="url_webhook" 
            :readOnly="true"
            @click="copyValue('update_url_webhook')"
          ></b-form-input>
      </b-form-group>
      <span class="subinfo">Para receber o PDF de sua nota, é necessário adicionar esta URL nas configurações de webhook no NotaZZ.</span>
    </div>

  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import NoteCenterIntegration from "@/services/resources/NoteCenterIntegration";
import TokenService from "@/services/resources/TokenService";
  
export default {
  name: "IntegrationsConfigUpdateNotaZZ",
  components: {
    Multiselect
  },
  props: {
    opendEdit: {
      type: Boolean,
      required: true
    },
    loadingUpdate: {
      type: Boolean,
      required: true
    },
    editGroupLoad: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'NotaZZ' })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    sugestionRedirect: {
      type: Object,
      required: true,
      default: () => ({
        url: null,
        name: null,
      })
    },
    removeError: {
      type: Function,
      required: true
    },
    removeErrors: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
  },
  data: () => ({
    token: '',
    url_webhook: '',
    use_name_product: {
      block: false,
      loading: false,
      value: null,
      items: [
        {
          name: 'Sim, exibir nome do produto na nota fiscal',
          value: true
        },
        {
          name: 'Não, não exibir nome do produto na nota fiscal',
          value: false
        }
      ]
    },
    send_email: {
      block: false,
      loading: false,
      value: null,
      items: [
        {
          name: 'Sim, enviar email com a nota fiscal para o cliente',
          value: true
        },
        {
          name: 'Não, não enviar email com a nota fiscal para o cliente',
          value: false
        }
      ]
    }
  }),
  methods: {
    copyValue(type) {
      const el = document.getElementById(type);
      el.select();
      document.execCommand("copy");
      this.messageSuccess('A Url foi copiada com sucesso', 'Copiado!');
    },
    setUrl(response) {
      this.url_webhook = `${process.env.VUE_APP_API_HOST}/api/retorno/notazz/?key=${response.api_key}`;
    },
    messageSuccess(msg, title) {
      this.$bvToast.toast(msg, {
        variant: "success",
        title: title,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    async getToken() {
      await TokenService.build().get('').then(response => {
        this.setUrl(response);
      });
    },
    async showEditCallback(data) {

      this.removeErrors([
        'update_token',
        'update_use_name_product',
        'update_send_email'
      ]);

      this.$emit('update:opendEdit', true);
      this.$emit('update:editGroupLoad', true);
      this.$emit('update:loadingUpdate', false);

      await this.getToken();

      this.token = data.token;
      this.use_name_product.value = this.use_name_product.items.find(item => item.value === data.use_name_product);
      this.send_email.value = this.send_email.items.find(item => item.value === data.send_email);

      this.$emit('update:editGroupLoad', false);
    },
    updateCallbacks() {

      this.$emit('update:loadingUpdate', true);

      NoteCenterIntegration.build().post('', {
        name: 'NotaZZ',
        config_integration: {
          token: this.token,
          use_name_product: this.use_name_product.value.value || false,
          send_email: this.send_email.value.value || false,
        },
        token: this.token,
        default: false
      }, { suppressErrorNotify: true })
      .then(() => {

        this.$emit('update:opendEdit', false);
        this.fetchCallbacks();

        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.success.message'), {
          title: this.$t('views.seller.integrations.config.toast.update.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
      .catch(error => {
        this.mountInputError(error.response.data, 'update_');
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.update.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
      .finally(() => {
        this.$emit('update:loadingUpdate', false);
      });
    },
  }
}

</script>